import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Avatar,
  Box,
  Tooltip,
  Divider,
  Typography,
} from "@mui/material";

import {
  ExpandLess,
  ExpandMore,
  Home,
  Business,
  Store,
  People,
  Security,
  BarChart,
  PeopleOutline,
  PeopleTwoTone,
  Diversity3,
  PinDrop,
  Source,
  AccountBalance,
  LocalShipping,
  AdminPanelSettings,
  Article,
} from "@mui/icons-material";
import { NavLink } from "react-router-dom";
import ArticleIcon from '@mui/icons-material/Article';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

//---------------- Auth---------------- 
import { AuthProvider, useAuth } from "./AuthContext";


const Sidebar = ({ open }) => {
  const [masterOpen, setMasterOpen] = useState(false);
  const [tranascationOpen, setTransactionOpen] = useState(false);
  const [accountsOpen, setAccountsOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);

  const [subMenuOpen, setSubMenuOpen] = useState({
    purchase: false,
    sale: false,
    stocks: false,
    Accounts: false,
  });

  const toggleSubMenu = (menu) => {
    setSubMenuOpen((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };
  const { companyName, companyId, isSuperAdmin, superCompanyId, permissions, roleName } = useAuth();

  {/* Permissions */ }
  const hasReadMasterPermission = permissions.includes('Read Master');
  const hasReadTransactionPermission = permissions.includes('Read Transaction');
  const hasReadAccountsPermission = permissions.includes('Read Accounts');
  const hasReadAdministrationPermission = permissions.includes('Read Administration');
  const hasReadReadReportsPermission = permissions.includes('Read Reports');

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: open ? 240 : 60,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: open ? 240 : 60,
          // background: "linear-gradient(180deg, #173B45 0%, #173B45 100%)",
          background: "linear-gradient(180deg, #0F353F 0%, #0F353F 100%)",
          color: "white",
          overflowX: "hidden",
          transition: "width 0.3s",
          borderRight: "none",
        },
      }}
    >
      {/* Profile */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          p: 2,
          justifyContent: open ? "flex-start" : "center",
        }}
      >
        {open && (
          <Box>

          </Box>
        )}
      </Box>
      <Divider sx={{ bgcolor: "rgba(255,255,255,0.2)" }} />

      <List style={{ marginTop: '20px' }}>
        {/* Home */}
        <Tooltip title="Home" placement="right" disableHoverListener={open}>
          <ListItemButton
            component={NavLink}
            to="/Home"
            sx={{
              "&.active": {
                bgcolor: "rgba(255,255,255,0.1)",
                borderLeft: "4px solid #4CAF50",
              },
            }}
          >
            <ListItemIcon>
              <Home sx={{ color: "whitesmoke" }} />
            </ListItemIcon>
            {open &&
              <ListItemText primary="Home"
                primaryTypographyProps={{
                  style: {
                    cursor: 'pointer',
                    fontFamily: '"brandon-grotesque-n7", "brandon-grotesque", sans-serif',
                    fontSize: '14px',
                    fontWeight: 'bold',
                  },
                }}
              />}
          </ListItemButton>
        </Tooltip>

        {/* Master Section */}
        {hasReadMasterPermission && (
          <ListItemButton onClick={() => setMasterOpen(!masterOpen)}>
            <ListItemIcon>
              <Business sx={{ color: "whitesmoke" }} />
            </ListItemIcon>
            {open &&
              <ListItemText primary="Master"
                primaryTypographyProps={{
                  style: {
                    cursor: 'pointer',
                    fontFamily: '"brandon-grotesque-n7", "brandon-grotesque", sans-serif',
                    fontSize: '14px',
                    fontWeight: 'bold',
                  },
                }}
              />}

            {open && (masterOpen ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )}

        <Collapse in={masterOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              component={NavLink}
              to="/CompanyEdit"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #2196F3",
                },
              }}
            >
              {open &&
                < ListItemText primary="Company"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/BranchIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #009688",
                },
              }}
            >
              {open &&
                < ListItemText primary="Branch"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/ShiftIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #8BC34A",
                },
              }}
            >
              {open &&
                < ListItemText primary="Shift"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/DepartmentIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #8BC34A",
                },
              }}
            >
              {open &&
                < ListItemText primary="Department"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/DesignationIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #8BC34A",
                },
              }}
            >
              {open &&
                < ListItemText primary="Designation"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/EmployeeIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #8BC34A",
                },
              }}
            >
              {open &&
                < ListItemText primary="Employee"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/BataSettingsIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #8BC34A",
                },
              }}
            >
              {open &&
                < ListItemText primary="Bata Settings"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

          </List>
        </Collapse>

        {hasReadMasterPermission && (
          <ListItemButton onClick={() => setTransactionOpen(!tranascationOpen)}>
            <ListItemIcon>
              <AccountBalanceIcon sx={{ color: "whitesmoke" }} />
            </ListItemIcon>
            {open &&
              <ListItemText primary="Transaction"
                primaryTypographyProps={{
                  style: {
                    cursor: 'pointer',
                    fontFamily: '"brandon-grotesque-n7", "brandon-grotesque", sans-serif',
                    fontSize: '14px',
                    fontWeight: 'bold',
                  },
                }}
              />}

            {open && (tranascationOpen ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        )}

        <Collapse in={tranascationOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              component={NavLink}
              to="/AttendanceIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #2196F3",
                },
              }}
            >
              {open &&
                < ListItemText primary="Attendance"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/PayRollIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #FF9800",
                },
              }}
            >
              {open &&
                <ListItemText primary="Pay Roll"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/SalaryAdvanceIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #FF9800",
                },
              }}
            >
              {open &&
                <ListItemText primary="Salary Advance"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/DriverBataIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #FF9800",
                },
              }}
            >
              {open &&
                <ListItemText primary="Drivers Bata"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>


          </List>
        </Collapse>

        {hasReadAdministrationPermission && (
          <ListItemButton onClick={() => setUserOpen(!userOpen)}>
            <ListItemIcon>
              <People sx={{ color: "whitesmoke" }} />
            </ListItemIcon>
            {open &&
              <ListItemText primary="Auth Zen"
                primaryTypographyProps={{
                  style: {
                    cursor: 'pointer',
                    fontFamily: '"brandon-grotesque-n7", "brandon-grotesque", sans-serif',
                    fontSize: '14px',
                    fontWeight: 'bold',
                  },
                }}
              />}
            {open && (userOpen ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>

        )}

        <Collapse in={userOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              component={NavLink}
              to="/UserIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid orange",

                },
              }}
            >
              {open &&
                < ListItemText primary="Users"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/RoleIndex"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #FF9800",
                },
              }}
            >
              {open &&
                < ListItemText primary="Roles"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>

            <ListItemButton
              component={NavLink}
              to="/PasswordChange"
              sx={{
                pl: open ? 4 : 2,
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid green",
                },
              }}
            >
              {open &&
                < ListItemText primary="Reset Password"
                  primaryTypographyProps={{
                    style: {
                      marginLeft: '55px',
                      fontFamily: 'monospace',
                      fontSize: '14px'
                    },
                  }} />}
            </ListItemButton>
          </List>
        </Collapse>

        {hasReadReadReportsPermission && (
          <>
            <ListItemButton onClick={() => setReportOpen(!reportOpen)}>
              <ListItemIcon>
                <BarChart sx={{ color: "whitesmoke" }} />
              </ListItemIcon>
              {open && (
                <ListItemText
                  primary="Reports"
                  primaryTypographyProps={{
                    style: {
                      cursor: "pointer",
                      fontFamily: '"brandon-grotesque-n7", "brandon-grotesque", sans-serif',
                      fontSize: "14px",
                      fontWeight: "bold",
                    },
                  }}
                />
              )}
              {open && (reportOpen ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>

            <Collapse in={reportOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>

                {/* Accounts */}
                <ListItemButton
                  onClick={() => toggleSubMenu("accounts")}
                  sx={{
                    pl: open ? 4 : 2,
                    bgcolor: subMenuOpen.accounts ? "rgba(156,39,176,0.15)" : "transparent",
                    "&:hover": { bgcolor: "rgba(156,39,176,0.25)" },
                  }}
                >

                  <ListItemIcon>
                    <AccountBalanceWalletIcon sx={{ color: "whitesmoke", marginLeft: "20px", fontSize: '19px' }} />
                  </ListItemIcon>

                  {open && (
                    <ListItemText
                      primary="Accounts"
                      primaryTypographyProps={{
                        style: {
                          fontFamily: "monospace",
                          fontSize: "14px",
                          fontWeight: "bold",
                          marginLeft: "10px",
                          color: "whitesmoke",
                        },
                      }}
                    />
                  )}
                  {open && (subMenuOpen.accounts ? <ExpandLess /> : <ExpandMore />)}
                </ListItemButton>

                <Collapse in={subMenuOpen.accounts} timeout="auto" unmountOnExit style={{ backgroundColor: 'rgba(156,39,176,0.25)' }}>
                  <List component="div" disablePadding>
                    <ListItemButton component={NavLink} to="/CashBook" sx={{ pl: 6, "&:hover": { bgcolor: "rgba(156,39,176,0.2)" } }}>
                      <ListItemText primary="Cash Book" primaryTypographyProps={{ style: { fontSize: "13px", fontFamily: "monospace", color: "whitesmoke", marginLeft: "5px" } }} />
                    </ListItemButton>
                  </List>
                </Collapse>
              </List>
            </Collapse>
          </>
        )}

      </List>
    </Drawer>

  );
};

export default Sidebar;
